import 'core-js';
import Vue from 'vue';
import VueMq from 'vue-mq';
import { mapState } from 'vuex';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import components from './components/index.js';
import store from './store/index.js';
import { ucfirst, upcase, unhandleize } from './filters/string.js';
import { money, moneyWithoutDecimals } from './filters/money.js';
import { getSizedImageUrl } from './filters/images.js';

import render from './helpers/module.js';

__webpack_public_path__ = window.__webpack_public_path__; // eslint-disable-line no-underscore-dangle, camelcase

const cssVars = require('../styles/settings/settings.scss');

Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);

Vue.use(VueMq, {
  breakpoints: {
    mobile: parseInt(cssVars.breakpointTablet, 10),
    tablet: parseInt(cssVars.breakpointDesktop, 10),
    desktop: parseInt(cssVars.breakpointFullWidth, 10),
    hd: Infinity,
  },
});

Vue.filter('ucfirst', ucfirst);
Vue.filter('upcase', upcase);
Vue.filter('unhandleize', unhandleize);
Vue.filter('money', money);
Vue.filter('moneyWithoutDecimals', moneyWithoutDecimals);
Vue.filter('image', getSizedImageUrl);
Vue.prototype.$shop = { ...window.BVA }

// If app proxy or challenge page (template is null)
const appProxy = window.BVA && !window.BVA.template;

new Vue({
  store,
  comments: true,
  components,
  computed: {
    ...mapState({
      checkout: (state) => state.cart.checkout,
    }),
  },
  created() {
    // 3rd party apps may add scripts and styles to our liquid templates that are incompatible with Vue.
    // This action moves them outside of the Vue instance. It was added to this project specifically
    // to accomodate the MagicPass Deals Club app.
    this.$store.dispatch('fixInteroperability/init');

    // on creation, initialize app data
    this.$store.dispatch('cart/init');
    this.$store.dispatch('products/init');

    // If app proxy or challenge page, move MainContent to body so Vue doesn't parse and the move back after mounted
    if (appProxy) {
      document.body.appendChild(document.getElementById('MainContentContainer'));
    }

    Vue.directive('disable-all', (el, binding) => {
      const tags = ["input", "button", "textarea", "select"];
      tags.forEach(tagName => {
        const nodes = el.getElementsByTagName(tagName);
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].disabled = binding.value;
          nodes[i].tabIndex = binding.value ? -1 : null;
        }
      });
    });
  },
  mounted() {
    // 3rd party apps may add scripts and styles to our liquid templates that are incompatible with Vue.
    // This action moves them outside of the Vue instance. It was added to this project specifically
    // to accomodate the MagicPass Deals Club app.
    this.$store.dispatch('fixInteroperability/restore');

    // If app proxy (template == null), move MainContent back to the correct place
    if (appProxy) {
      document.getElementById('MainContent').appendChild(document.getElementById('MainContentContainer'));
    }

    // on mount, start listening for load events
    // on a section load, re-mount section to reflect admin changes
    document.addEventListener('shopify:section:load', (event) => {
      const sectionContainer = document.getElementById(event.target.id);
      const NewComponent = Vue.extend({
        components,
        template: event.target.innerHTML,
      });
      const component = new NewComponent().$mount();

      sectionContainer.innerHTML = '';
      sectionContainer.appendChild(component.$el);
    });
  },
}).$mount('#app');

function renderProductTiles(){
  const vueRoots = document.querySelectorAll('[data-vue-root]');
  vueRoots.forEach((root) => {
    render({
      root,
      component: new Vue({ store }),
      is: components[root.dataset.vueRoot],
    });
  });
}

(function () {
  window.addEventListener('change', () => {
    setTimeout(() => {
      renderProductTiles()
    }, 1500)
  })
})();
